/* eslint-disable no-underscore-dangle */
import styled, { css } from 'styled-components';

import { media, grid } from 'app/shared/styles_js/variables';

import { isNumeric, isColVal, colPercent, generateContainerCss } from './utils';
/**
 * @description
 * Grid container
 */

export const GridContainerSt = styled.div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;

  ${({ fluidBreakpoints = [] }) => generateContainerCss(fluidBreakpoints)}
`;

/**
 * @description
 * Grid row
 */
export const GridRowSt = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: ${-1 * grid.gutter.sm}px;
  margin-left: ${-1 * grid.gutter.sm}px;
  ${media.md(css`
    margin-right: ${-1 * grid.gutter.md}px;
    margin-left: ${-1 * grid.gutter.md}px;
  `)};
`;

/**
 * @description
 * Grid col
 */

/**
 * @param {Number} num
 */
export const GridColSt = styled.div`
  max-width: 100%;
  flex: 0 0 auto;
  padding-right: ${grid.gutter.sm}px;
  padding-left: ${grid.gutter.sm}px;

  ${({ sm }) =>
    isColVal(sm) &&
    css`
      max-width: ${colPercent(sm)};
      flex: 0 0 ${colPercent(sm)};
    `};

  ${({ smOffset }) =>
    isColVal(smOffset) &&
    css`
      margin-left: ${colPercent(smOffset)};
    `}

  ${({ smOrder }) =>
    isNumeric(smOrder) &&
    css`
      order: ${smOrder};
    `}

  ${media.md(css`
    padding-right: ${grid.gutter.md}px;
    padding-left: ${grid.gutter.md}px;
    ${({ md }) =>
      isColVal(md) &&
      css`
        max-width: ${colPercent(md)};
        flex: 0 0 ${colPercent(md)};
      `}

  ${({ mdOffset }) =>
    isColVal(mdOffset) &&
    css`
      margin-left: ${colPercent(mdOffset)};
    `}

    ${({ mdOrder }) =>
      isNumeric(mdOrder) &&
      css`
        order: ${mdOrder};
      `}     
  `)};

  ${media.lg(css`
    ${({ lg }) =>
      isColVal(lg) &&
      css`
        max-width: ${colPercent(lg)};
        flex: 0 0 ${colPercent(lg)};
      `}

    ${({ lgOffset }) =>
      isColVal(lgOffset) &&
      css`
        margin-left: ${colPercent(lgOffset)};
      `}

    ${({ lgOrder }) =>
      isNumeric(lgOrder) &&
      css`
        order: ${lgOrder};
      `}   
  `)};

  ${media.xl(css`
    ${({ xl }) =>
      isColVal(xl) &&
      css`
        max-width: ${colPercent(xl)};
        flex: 0 0 ${colPercent(xl)};
      `}
    ${({ xlOffset }) =>
      isColVal(xlOffset) &&
      css`
        margin-left: ${colPercent(xlOffset)};
      `}

    ${({ xlOrder }) =>
      isNumeric(xlOrder) &&
      css`
        order: ${xlOrder};
      `}       
  `)};
`;
